// extracted by mini-css-extract-plugin
module.exports = {"collectionContent":"CollectionPage_collectionContent__LFagY","divider":"CollectionPage_divider__2mTCt","emptyListContainer":"CollectionPage_emptyListContainer__k7lSj"};